import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { Provider } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';
import { history, store } from 'flow/configure-store';
import { setAdminLocation } from 'flow/components/admin-location';
import EmbedApplication from 'flow/routes/embed-application';
import ContextComponent from 'flow/route-components/ContextComponent';
import UserRegionProvider from 'flow/contexts/UserRegionProvider';
import { ModalProvider } from 'flow/contexts/ModalProvider';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var getRoutes = function getRoutes() {
  return /*#__PURE__*/_jsx(Provider, {
    store: store,
    children: /*#__PURE__*/_jsx(ModalProvider, {
      children: /*#__PURE__*/_jsx(UserRegionProvider, {
        children: /*#__PURE__*/_jsx(Router, {
          history: history,
          children: /*#__PURE__*/_jsxs(Switch, {
            children: [/*#__PURE__*/_jsx(Route, {
              path: "/embed/:type/*",
              component: EmbedApplication
            }), /*#__PURE__*/_jsx(Route, {
              path: "/embed/:type",
              component: EmbedApplication
            }), /*#__PURE__*/_jsx(Route, {
              component: setAdminLocation(ContextComponent)
            }), /*#__PURE__*/_jsx(Route, {
              path: "*",
              component: PageNotFound
            })]
          })
        })
      })
    })
  });
};
var PageNotFound = /*#__PURE__*/function (_React$PureComponent) {
  function PageNotFound() {
    _classCallCheck(this, PageNotFound);
    return _callSuper(this, PageNotFound, arguments);
  }
  _inherits(PageNotFound, _React$PureComponent);
  return _createClass(PageNotFound, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        children: 'Page not found'
      });
    }
  }]);
}(React.PureComponent);
export default getRoutes;